import type { ExploreValues } from '../types';

export interface EmbeddedLeadFormExploreValues extends ExploreValues {
  companyName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  industry?: string;
  numberEmployees?: string | number;
  phone?: string;
}

export enum LeadOriginSubtypeValue {
  LEARNING_JOURNEY_FORM = 'Product Registration Form',
}

export enum SubmittedFromValue {
  LEARNING_JOURNEY_FORM = 'Embedded Explore Lead Form',
}
